const ROLE = {
	ROLE_NONE: "None",
	ROLE_USER: "User",
	ROLE_ADMINISTRATOR: "Admin",
	ROLE_ADMINDONVI: "Unit Admin",
};

export default ROLE;
